export enum FilterType {
    All,
    Premium,
    Free,
}
export enum SortType {
    None = 'none',
    AZ = 'az',
    ZA = 'za',
}
export enum TypeFilter {
    All = 'all',
    Premium = 'premium',
    Free = 'free',
}

export const ALL_GROUPS = 'all';
